import axios from 'axios';

const api = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// 1. Intercepteur de REQUÊTE : Ajoute le token s'il existe
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// 2. Intercepteur de RÉPONSE : Gère les erreurs globales
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // On ne déconnecte QUE si on a un token mais que le serveur dit qu'il est invalide
        const token = localStorage.getItem('auth_token');

        if (error.response?.status === 401 && token) {
            localStorage.removeItem('auth_token');
            // On évite de rediriger si on est déjà sur login ou register
            if (!['/login', '/register'].includes(window.location.pathname)) {
                window.location.href = '/login?expired=true';
            }
        }
        return Promise.reject(error);
    }
);

export default api;